import React, { useState, useEffect } from "react";
import { solicitarResetSenha } from "./AuthService";

const ResetPassword = ({ isLoggedIn, setIsLoggedIn, setAuthResponseDTO }) => {
    const [usernameEmailInput, setUsernameEmailInput] = useState({
        usernameEmail: "",
    });
    const [mensagemDeRetorno, setMensagemDeRetorno] = useState("");
    const [habilitarBotao, setHabilitarBotao] = useState(true);

    useEffect(() => {
        localStorage.clear();
    }, []);

    const handleSubmit = (event) => {
        setHabilitarBotao(false);
        event.preventDefault();
        solicitarResetSenha(usernameEmailInput)
            .then((response) => {
                setMensagemDeRetorno(response);
                setHabilitarBotao(true);
            })
            .catch((error) => {
                console.error("Erro ao acessar a API:", error);
            });
    };

    const handleChange = (e) => {
        setUsernameEmailInput({
            ...usernameEmailInput,
            usernameEmail: e.target.value,
        });
    };

    return (
        <section className="bg-gradient-to-br from-teal-400 via-teal-500 to-teal-600">
            <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                            Redefinir a senha
                        </h1>
                        <span className="text-sm">
                            Informe seu usuário ou e-mail para redefinir sua
                            senha.
                        </span>
                        <form
                            className="max-w-sm mx-auto"
                            onSubmit={handleSubmit}
                        >
                            <label
                                for="username-email-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                                Usuário ou e-mail
                            </label>
                            <div className="relative">
                                <input
                                    value={usernameEmailInput.usernameEmail}
                                    type="text"
                                    onInput={handleChange}
                                    id="username-email-input"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Informe o usuário ou o e-mail cadastrado"
                                />
                                <p
                                    className={`mt-2 text-sm font-medium text-${
                                        mensagemDeRetorno?.includes("enviado")
                                            ? "green"
                                            : "red"
                                    }-600`}
                                >
                                    {mensagemDeRetorno}
                                </p>
                            </div>
                            <div className="d-grid gap-2 mt-3">
                                <button
                                    disabled={!habilitarBotao}
                                    type="submit"
                                    className="w-full text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    {habilitarBotao && <>Enviar</>}
                                    {!habilitarBotao && (
                                        <>
                                            <svg
                                                aria-hidden="true"
                                                role="status"
                                                class="inline w-4 h-4 me-3 text-white animate-spin"
                                                viewBox="0 0 100 101"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="#E5E7EB"
                                                />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                            Aguarde...
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ResetPassword;
